import ReactGA from "react-ga4";

export const initGA = () => {
	ReactGA.initialize("G-8PTNPH1XDQ");
};

export const logPageView = (path: string) => {
	ReactGA.send({ hitType: "pageview", page: path });
};
